/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Container } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <nav>

          </nav>
          <div className="copyright">
            &copy; {1900 + new Date().getYear()},

            . Developed by{" "}
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ahmed Abosaif
            </a>
            .
          </div>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
